<template>
    <div class="topTab">
      <div class="left">
        <div class="icon">
            <img src="@/assets/top_tab_logo.png">
        </div>
      </div>

      <div class="mid">
        <div class="mind_item" @click="handleTab(0)">Products Advantages</div>
        <div class="mind_item" @click="handleTab(1)">Loan Process</div>
        <div class="mind_item" @click="handleTab(2)">Company Introduction</div>
        <div class="mind_item" @click="handleTab(3)">QA</div>
        <div class="mind_item" @click="handleTab(4)">Privacy Policy</div>
      </div>
      <div class="right">ID</div>
    </div>
  </template>

  <script>
  export default {
    data() {
      return {
        active: 0,
      };
    },
    created() {
    },
    methods:{
      navbarHandleLeft() {
        this.$router.push({
          path:'repayment/detail'
        })
      },
      handleTab(index) {
        this.$emit('handleTab',index)
      }
    }
  };
  </script>

  <style lang="scss" scoped>
  .topTab {
    display: flex;
    justify-content: space-between;
    padding: 45px 177px;
    .left {
        .icon {
            width: 248px;
            height: 39px;
            img {
                width: 100%;
                height: 100%;
            }
        }
    }
    .mid {
      flex: 1;
      width: 100%;
      display: flex;
      justify-content: space-between;
      padding: 0 90px;
      font-family: 'Lexend_Regular';
      font-weight: 500;
      font-size: 19px;
      color: #000000;
      line-height: 39px;
      .mind_item {
        cursor: pointer;
      }
      .mind_id {
        margin-left: 61px;
        width: 73px;
        height: 32px;
        line-height: 32px;
        background: url('./../assets/ID.png') 0 0 no-repeat;
        background-size: 100% 100%;
        padding-left: 15px;
        box-sizing: border-box;
      }
    }
    .right {
      width: 73px;
      height: 32px;
      line-height: 32px;
      background: url('./../assets/ID.png') 0 0 no-repeat;
      background-size: 100% 100%;
      padding-left: 15px;
      box-sizing: border-box;
    }
  }
  </style>



// WEBPACK FOOTER //
// src/components/topTab.vue